/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style';
import Widget from '../../widget';
import { getRows } from './helper';

export default function MercuryUseOverview() {
  const { t } = useTranslation();
  const rows = useMemo(() => getRows(t), [t]);

  return (
    <Widget
      className="with-border-header widget-custom-type-a no-flex"
      title={t('Overview')}
    >
      <Style>
        {rows.map((row, i) => (
          <div className='flex row-item justify-content-between' key={`row-${i}`}>
            <div className="flex flex-column justify-content-center">
              <label>{row.label}</label>
            </div>
            <div className="flex flex-column justify-content-center">
              {row.render()}
            </div>
          </div>
        ))}
      </Style>
    </Widget>
  )
}
